module.exports = __webpack_public_path__ + "img/brain.01b4567c.svg";